import script from "./Groep.vue?vue&type=script&lang=ts&setup=true"
export * from "./Groep.vue?vue&type=script&lang=ts&setup=true"

import "./Groep.vue?vue&type=style&index=0&id=1aef3c0e&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./../views/locale/Optin.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CJenkins%5Cworkspace%5CConsumerSettings_master%5Cfrontend%5Csrc%5Ccomponents%5CGroep.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Jenkins\\workspace\\ConsumerSettings_master\\frontend\\.yarn\\__virtual__\\vue-loader-virtual-12f41bf58f\\5\\YarnPackageCache\\vue-loader-npm-17.0.0-6ebaa2d3c5-0c0a647a4e.zip\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1aef3c0e"]])

export default __exports__